import { ref } from 'vue';

export function useAttemptLimit(categories) {
    const counts = ref(
        Object.fromEntries(Object.keys(categories).map(k => [k, 0]))
    );

    function hasReachedMax(category) {
        return counts.value[category] >= categories[category];
    }

    function isLastAttempt(category) {
        return categories[category] - counts.value[category] === 1;
    }

    function increment(category) {
        counts.value[category]++;
    }

    function reset(category) {
        counts.value[category] = 0;
    }

    return { counts, hasReachedMax, isLastAttempt, increment, reset };
}
